var map = {
	"./about.vue": "072f",
	"./contact.vue": "feb7",
	"./gallery.vue": "fa05",
	"./hero.vue": "3f29",
	"./projectslider.vue": "24c4",
	"./skillslist.vue": "e864",
	"./textimage.vue": "0fec",
	"./textonly.vue": "bbf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbe0";